module.exports = __webpack_public_path__ + "img/elements_graphiques-08.af17cd87.png";